import {createContext} from "react"
export const TeamContext = createContext({
    teamContext: null,
    setTeamAction: () => {},
})